import { createContext } from 'react'

export const WishlistContext = createContext({})

export const WishlistProvider = WishlistContext.Provider
export const WishlistConsumer = WishlistContext.Consumer
